import moment from 'moment'

export enum DaysOfWeek {
  Sunday = 'sun',
  Monday = 'mon',
  Tuesday = 'tue',
  Wednesday = 'wed',
  Thursday = 'thu',
  Friday = 'fri',
  Saturday = 'sat'
}

export enum TimeUnit {
  day = 'day',
  week = 'week',
  month = 'month',
  year = 'year'
}

export const TIME_INTERVAL_OPTIONS = [
  { interval: 'Minutes', multiplier: 1 },
  { interval: 'Hours', multiplier: 60 },
  { interval: 'Days', multiplier: 1440 },
  { interval: 'Weeks', multiplier: 10080 }
]

const getIntervalInMinutes = (interval: string, minutes: number) => {
  if (interval === 'Minutes') {
    return minutes
  }
  if (interval === 'Hours') {
    return minutes * 60
  }
  if (interval === 'Days') {
    return minutes * 1440
  }
  if (interval === 'Weeks') {
    return minutes * 10080
  }
  return minutes
}

const assumeIntervalFromMinutes = (minutes: number) => {
  if (minutes === 0 || minutes === null || minutes < 0) {
    return [0, 'Minutes']
  }
  const inHours = minutes / 60
  const inDays = minutes / 1440
  const inWeeks = minutes / 10080
  const validValues = [inHours, inDays, inWeeks].filter(num =>
    Number.isInteger(num)
  )
  const minValue = Math.min(...validValues)
  if (minValue === inHours) {
    return [inHours, 'Hours']
  }
  if (minValue === inDays) {
    return [inDays, 'Days']
  }
  if (minValue === inWeeks) {
    return [inWeeks, 'Weeks']
  }
  return [minutes, 'Minutes']
}

export const DELETED_CHANNEL = 'Deleted channel'

const getChannelValue = (channels: APIChannel[], channelId: string) =>
  channels.find(channel => channel.id === channelId)?.value ?? DELETED_CHANNEL

export const mapToServer = (
  reminder: LocalReminder,
  userId: string
): APIReminder => {
  const { id, stamp, alerts, created_at, updated_at, ...rest } = reminder
  return {
    ...rest,
    user_id: userId,
    stamp: stamp.toISOString(),
    alerts: alerts.map(reminder => {
      return {
        channel_id: reminder.channel_id === 'Push' ? null : reminder.channel_id,
        minutes_before: getIntervalInMinutes(
          reminder.multiplier,
          reminder.minutes_before
        )
      }
    })
  }
}

export const mapFromServer = (
  reminder: APIReminder,
  user: LocalUser
): LocalReminder => {
  const { stamp, alerts, repeat, ...rest } = reminder
  return {
    ...rest,
    stamp: moment(stamp),
    repeat:
      repeat === null
        ? null
        : {
            ...repeat,
            ends_on: repeat.ends_on === null ? null : moment(repeat.ends_on)
          },
    alerts: alerts.map(reminder => {
      const [minutes, interval] = assumeIntervalFromMinutes(
        reminder.minutes_before
      )
      const value = getChannelValue(user.channels, reminder.channel_id)
      return {
        channel_id:
          reminder.channel_id === null
            ? 'Push'
            : value === DELETED_CHANNEL
            ? DELETED_CHANNEL
            : reminder.channel_id,
        minutes_before: minutes,
        multiplier: interval,
        channel_value: reminder.channel_id === null ? 'Push' : value
      }
    })
  }
}
